export const messages = {
    open: 'Open navigation menu',
    view: 'View alerts',
    search: 'Search for a location',
}
